var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "status-template-container" }, [
    _vm.renderOnlyOneStatus
      ? _c("span", { class: _vm.className }, [
          _vm._v(_vm._s(_vm.texts.sentToFirma)),
        ])
      : _c(
          "ul",
          { staticClass: "status-list" },
          _vm._l(_vm.multipleStatus, function (status, index) {
            return _c(
              "li",
              {
                key: index,
                class: [_vm.multipleStatusClassName(status), "audit-grid-item"],
              },
              [_vm._v(_vm._s(_vm.multipleStatus[index]))]
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }